module.exports = __webpack_public_path__ + "img/damas.3e1a5a5a.jpg";